define('home/templates/notificationCardUpvote',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"card__reason\">\n<div class=\"notification__icon -upvote text-brand\">\n<span class=\"icon-arrow-up text-smaller\"></span>\n</div>"
    + alias2(helpers.gettext.call(alias1,"%(userNames)s upvoted you on %(thread)s",{"name":"gettext","hash":{"thread":helpers.getPartial.call(alias1,"threadLink",{"name":"getPartial","hash":{},"data":data}),"userNames":helpers.getPartial.call(alias1,"userGroupNames",{"name":"getPartial","hash":{},"data":data})},"data":data}))
    + "\n\n<span class=\"time text-gray\">"
    + alias2(container.lambda((depth0 != null ? depth0.relativeTime : depth0), depth0))
    + "</span>\n</div>\n<div class=\"card__content -notification\">\n<div data-role=\"post\"></div>\n</div>\n";
},"useData":true})

});
